module.exports = "./images/empty.f8553193.png";